import { useEffect, useState } from 'react';
import { subscribeLoading } from '../lib/api';

// Thin bar under the status bar while data is loading. It waits a moment before showing, so quick loads
// (most of them) don't flash it.
const DELAY_MS = 250;

export default function LoadingBar() {
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeLoading(setLoading), []);
  useEffect(() => {
    if (!loading) {
      setVisible(false);
      return undefined;
    }
    const timer = setTimeout(() => setVisible(true), DELAY_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  if (!visible) return null;
  return (
    <div role="progressbar" aria-label="Đang tải" className="loading-bar pointer-events-none fixed inset-x-0 z-50 h-[3px] overflow-hidden"
      style={{ top: 'env(safe-area-inset-top, 0px)' }}>
      <div className="loading-bar-fill h-full bg-primary" />
    </div>
  );
}
